<div class="metric-settings-tile">
  <div class="row">
    <div class="tile-name">
      {{ metric?.long_name }}
    </div>
  </div>
  <div class="row">
    <div class="overall-subtitle">
      {{ selectedMetricData?.charts?.overall?.subtitle }}
    </div>
  </div>
  <div class="row">
    <div
      *ngIf="
        goals &&
        goals.updatedData &&
        district &&
        district.data &&
        goals.updatedData[district.data.id] &&
        !goals.updatedData[district.data.id].inactive
      "
      class="district-goal"
    >
      <span *ngIf="metric?.up_is_good">></span>
      <span *ngIf="!metric?.up_is_good"><</span>
      <span class="goal-and-suffix"
        >{{ goals.updatedData[district.data.id].goal
        }}{{ metric?.data_suffix }}</span
      >
    </div>
  </div>
  <div class="row">
    <div
      class="district-goal-subtitle"
      *ngIf="
        goals &&
        goals.updatedData &&
        district &&
        district.data &&
        goals.updatedData[district.data.id] &&
        !goals.updatedData[district.data.id].inactive
      "
    >
      District Goal
    </div>
    <div
      class="district-goal-subtitle no-goal-set"
      *ngIf="
        goals &&
        goals.updatedData &&
        (!district ||
          !district.data ||
          !goals.updatedData[district.data.id] ||
          goals.updatedData[district.data.id].inactive)
      "
    >
      No district goal set
    </div>
  </div>
  <div class="row">
    <p
      class="overall-value"
      [ngStyle]="{ color: getColor() }"
      *ngIf="selectedMetricData?.charts?.overall?.chartData"
    >
      {{ selectedMetricData?.charts?.overall?.chartData[0]?.y
      }}{{ selectedMetricData?.dataSuffix }}
    </p>
    <p
      class="overall-value-no-data"
      *ngIf="!selectedMetricData?.charts?.overall?.chartData"
    >
      No data available
    </p>
  </div>
  <div
    class="row trend-row"
    *ngIf="
      selectedMetricData?.charts?.overall?.chartData &&
      selectedMetricData?.charts?.overall?.chartData.length > 1
    "
  >
    <img [src]="partialImagePath + getTrendImg()" class="trendImg" />
    <span class="trend-text"
      >{{ trend }} {{ selectedMetricData?.trendSuffix }} from
      {{ selectedMetricData?.charts?.overall?.chartData[1]?.name }}</span
    >
  </div>
  <div class="row view-select-btn-row">
    <view-select-buttons
      [chartNames]="getChartNames()"
      [selectedChart]="'overall'"
      [disableBtns]="true"
      class="view-selector"
    ></view-select-buttons>
  </div>
</div>
